var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as Utils from '@datocms/rest-client-utils';
import BaseResource from '../../BaseResource';
var ItemTypeFilter = /** @class */ (function (_super) {
    __extends(ItemTypeFilter, _super);
    function ItemTypeFilter() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Create a new filter
     *
     * Read more: https://www.datocms.com/docs/content-management-api/resources/item-type_filter/create
     *
     * @throws {ApiError}
     * @throws {TimeoutError}
     */
    ItemTypeFilter.prototype.create = function (body) {
        return this.rawCreate(Utils.serializeRequestBody(body, {
            type: 'item_type_filter',
            attributes: ['name', 'filter', 'columns', 'order_by', 'shared'],
            relationships: ['item_type'],
        })).then(function (body) {
            return Utils.deserializeResponseBody(body);
        });
    };
    /**
     * Create a new filter
     *
     * Read more: https://www.datocms.com/docs/content-management-api/resources/item-type_filter/create
     *
     * @throws {ApiError}
     * @throws {TimeoutError}
     */
    ItemTypeFilter.prototype.rawCreate = function (body) {
        return this.client.request({
            method: 'POST',
            url: '/item-type-filters',
            body: body,
        });
    };
    /**
     * Update a filter
     *
     * Read more: https://www.datocms.com/docs/content-management-api/resources/item-type_filter/update
     *
     * @throws {ApiError}
     * @throws {TimeoutError}
     */
    ItemTypeFilter.prototype.update = function (itemTypeFilterId, body) {
        return this.rawUpdate(Utils.toId(itemTypeFilterId), Utils.serializeRequestBody(body, {
            id: Utils.toId(itemTypeFilterId),
            type: 'item_type_filter',
            attributes: ['name', 'columns', 'order_by', 'shared', 'filter'],
            relationships: ['item_type'],
        })).then(function (body) {
            return Utils.deserializeResponseBody(body);
        });
    };
    /**
     * Update a filter
     *
     * Read more: https://www.datocms.com/docs/content-management-api/resources/item-type_filter/update
     *
     * @throws {ApiError}
     * @throws {TimeoutError}
     */
    ItemTypeFilter.prototype.rawUpdate = function (itemTypeFilterId, body) {
        return this.client.request({
            method: 'PUT',
            url: "/item-type-filters/".concat(itemTypeFilterId),
            body: body,
        });
    };
    /**
     * List all filters
     *
     * Read more: https://www.datocms.com/docs/content-management-api/resources/item-type_filter/instances
     *
     * @throws {ApiError}
     * @throws {TimeoutError}
     */
    ItemTypeFilter.prototype.list = function () {
        return this.rawList().then(function (body) {
            return Utils.deserializeResponseBody(body);
        });
    };
    /**
     * List all filters
     *
     * Read more: https://www.datocms.com/docs/content-management-api/resources/item-type_filter/instances
     *
     * @throws {ApiError}
     * @throws {TimeoutError}
     */
    ItemTypeFilter.prototype.rawList = function () {
        return this.client.request({
            method: 'GET',
            url: '/item-type-filters',
        });
    };
    /**
     * Retrieve a filter
     *
     * Read more: https://www.datocms.com/docs/content-management-api/resources/item-type_filter/self
     *
     * @throws {ApiError}
     * @throws {TimeoutError}
     */
    ItemTypeFilter.prototype.find = function (itemTypeFilterId) {
        return this.rawFind(Utils.toId(itemTypeFilterId)).then(function (body) {
            return Utils.deserializeResponseBody(body);
        });
    };
    /**
     * Retrieve a filter
     *
     * Read more: https://www.datocms.com/docs/content-management-api/resources/item-type_filter/self
     *
     * @throws {ApiError}
     * @throws {TimeoutError}
     */
    ItemTypeFilter.prototype.rawFind = function (itemTypeFilterId) {
        return this.client.request({
            method: 'GET',
            url: "/item-type-filters/".concat(itemTypeFilterId),
        });
    };
    /**
     * Delete a filter
     *
     * Read more: https://www.datocms.com/docs/content-management-api/resources/item-type_filter/destroy
     *
     * @throws {ApiError}
     * @throws {TimeoutError}
     */
    ItemTypeFilter.prototype.destroy = function (itemTypeFilterId) {
        return this.rawDestroy(Utils.toId(itemTypeFilterId)).then(function (body) {
            return Utils.deserializeResponseBody(body);
        });
    };
    /**
     * Delete a filter
     *
     * Read more: https://www.datocms.com/docs/content-management-api/resources/item-type_filter/destroy
     *
     * @throws {ApiError}
     * @throws {TimeoutError}
     */
    ItemTypeFilter.prototype.rawDestroy = function (itemTypeFilterId) {
        return this.client.request({
            method: 'DELETE',
            url: "/item-type-filters/".concat(itemTypeFilterId),
        });
    };
    ItemTypeFilter.TYPE = 'item_type_filter';
    return ItemTypeFilter;
}(BaseResource));
export default ItemTypeFilter;
//# sourceMappingURL=ItemTypeFilter.js.map